import { useState } from "react";
import useApi from "../../api";
import { toast } from "react-toastify";
import { NxtbnDrawer } from "../../components";
import { NXForm, InputField } from "../../components/common";

function CreateCustomer({
  isOpen,
  onClose,
  onCreate,
}: {
  isOpen: boolean;
  onClose: () => void;
  onCreate?: (option: any) => void;
}) {
  const api = useApi();
  const [formData, setFormData] = useState<any>({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    address: {
      street_address: '',
      city: '',
      state: '',
      postal_code: '',
      country: '',
      phone_number: '',
    },
  });

  const [errorData, setErrorData] = useState<any>({});


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    
    if (name.startsWith("address.")) {
      const addressField = name.split(".")[1];
      setFormData((prevData: any) => ({
        ...prevData,
        address: {
          ...prevData?.address,
          [addressField]: value,
        },
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleCreateCustomer = (e: React.FormEvent) => {
    e.preventDefault();
    api.createCustomer(formData)
      .then((response: any) => {
        toast.success("Customer created successfully");
        onClose();
        onCreate?.({label: response.full_name || response.username, value: response.id});
      })
      .catch((error: any) => {
        toast.error("Error creating customer");
        setErrorData(error.response.data)
      });
  };

  return (
    <NxtbnDrawer title="Create Customer" isOpen={isOpen} onClose={onClose}>
      <NXForm
        className="p-4"
        onSubmit={handleCreateCustomer}
        title="Customer Information"
        nonFieldError={{}}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">First Name</label>
            <InputField
              type="text"
              name="first_name"
              placeholder="First Name"
              value={formData.first_name}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Last Name</label>
            <InputField
              type="text"
              name="last_name"
              placeholder="Last Name"
              value={formData.last_name}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <InputField
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Phone Number</label>
            <InputField
              type="text"
              name="phone_number"
              placeholder="Phone Number"
              value={formData.phone_number}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
        </div>

        <hr className="my-4" />

        <h2 className="text-lg font-semibold mb-2">Address Information</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">First Name</label>
            <InputField
              type="text"
              name="address.first_name"
              placeholder="First Name"
              value={formData?.address?.first_name || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Last Name</label>
            <InputField
              type="text"
              name="address.last_name"
              placeholder="Last Name"
              value={formData?.address?.last_name || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Street Address</label>
            <InputField
              type="text"
              name="address.street_address"
              placeholder="Street Address"
              value={formData?.address?.street_address || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">City</label>
            <InputField
              type="text"
              name="address.city"
              placeholder="City"
              value={formData?.address?.city || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">State</label>
            <InputField
              type="text"
              name="address.state"
              placeholder="State"
              value={formData?.address?.state || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Postal Code</label>
            <InputField
              type="text"
              name="address.postal_code"
              placeholder="Postal Code"
              value={formData?.address?.postal_code || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Country</label>
            <InputField
              type="text"
              name="address.country"
              placeholder="Country"
              value={formData?.address?.country || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Address Phone Number</label>
            <InputField
              type="text"
              name="address.phone_number"
              placeholder="Address Phone Number"
              value={formData?.address?.phone_number || ''}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>
        </div>

        <div className="flex justify-end mt-4">
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm">
            Create Customer
          </button>
        </div>
      </NXForm>
    </NxtbnDrawer>
  );
}

export default CreateCustomer;
